import { RouterLink } from "../../../../../../../components/router-link";

interface Props {
  catalogId: string;
  label: string;
}

export const CatalogsDetailLinkCell = ({ catalogId, label }: Props) => {
  return (
    <RouterLink params={{ catalogId }} to={"/app/catalogs/catalog/$catalogId"} underline="hover">
      {label}
    </RouterLink>
  );
};
